import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';
import supabase from './utils/supabaseClient';

const STORAGE_KEY = 'fretz_cookie_consent_v1';
const COOKIES_VERSION = '2.0-2026-05-01';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        // Atrasa um pouco pra não competir com o LCP da home
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch {
      // localStorage indisponível (modo privado etc.) — não mostra
    }
  }, []);

  const accept = (level) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ level, at: new Date().toISOString(), version: COOKIES_VERSION }));
    } catch { /* ignore */ }
    setVisible(false);

    // Aceite cookies não obrigatoriamente vinculado a um e-mail.
    // Registramos quando o usuário está autenticado, para auditoria.
    supabase.auth.getUser().then(({ data }) => {
      const email = data?.user?.email;
      if (!email) return;
      supabase.from('aceites_legais').insert([{
        email,
        user_id: data.user.id,
        doc_tipo: 'cookies',
        doc_versao: COOKIES_VERSION,
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
        metadata: { level },
      }]).then(({ error }) => {
        if (error) console.warn('cookie consent log:', error);
      });
    });
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
      className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 sm:bottom-4 z-50 sm:max-w-md"
    >
      <div className="bg-white rounded-2xl shadow-2xl border border-ink-100 p-5">
        <div className="flex items-start gap-3">
          <div className="flex-1 text-sm text-ink-700 leading-relaxed">
            <p className="font-display font-bold text-ink-900 mb-1">Cookies & privacidade</p>
            <p>
              Usamos cookies estritamente necessários para o funcionamento do
              site e cookies opcionais para análise de uso. Você pode aceitar
              todos ou apenas os essenciais. Saiba mais na{' '}
              <Link to="/privacidade" className="text-brand-700 underline">
                Política de Privacidade
              </Link>.
            </p>
          </div>
          <button
            onClick={() => accept('essenciais')}
            aria-label="Aceitar apenas essenciais e fechar"
            className="p-1 rounded-lg hover:bg-ink-100 text-ink-400 shrink-0"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-2">
          <button
            onClick={() => accept('essenciais')}
            className="btn-secondary text-sm py-2.5"
          >
            Só essenciais
          </button>
          <button
            onClick={() => accept('todos')}
            className="btn-primary text-sm py-2.5"
          >
            Aceitar todos
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
